// Golf 7 (0048; docs/onderzoek/soera-leren.md §4.8 en §4.10): de webapp van 'Soera's leren'
// (appText.memorize). Toon: je-vorm, korte zinnen, rustig en volwassen (DESIGN §8.SL). Woordkeuze:
// 'uit het hoofd', 'laten horen', 'goed gehoord'. Nooit: opdreunen, stampen, afvinken, level,
// score, uitdaging, streak, toets, game, spel. Geen vergelijken tussen kinderen.
//
// `consent.text` en `consent.check` (één kind) en `consent.textMany` en `consent.checkMany` (twee
// of meer kinderen, één keer gevraagd met alle namen; oprichter 1 okt) zijn de toestemmingstekst:
// wie ze wijzigt, maakt een nieuwe LEARNING_CONSENT_VERSION met een nieuwe hash
// (packages/domain/src/privacy/childConsent.ts; de test in apps/api herberekent hem). POORT: jurist
// (tekst) en moedertaalsprekers.
export const appMemorizeNl = {
    title: "Soera's leren",
    nav: 'Leerdoelen',
    card: {
        body: "Bijhouden welke soera's jullie kinderen uit hun hoofd leren. Een kind laat horen, jij luistert in het echt en zegt 'Goed gehoord'. Pas dan komen er punten.",
        question: 'Bijhouden?',
        yes: 'Ja',
        notNow: 'Nee, niet nu',
        notNowDone: 'Goed. Je kunt het hier later altijd aanzetten.',
        on: 'Staat aan voor {names}.',
        open: 'Naar Leerdoelen',
        settings: 'Instellingen',
        renewal: 'Geef eerst opnieuw toestemming in Wat past bij ons gezin.',
    },
    wizard: {
        title: "Soera's leren aanzetten",
        step: 'Stap {n} van 4',
        back: 'Vorige',
        next: 'Volgende',
        done: 'Aanzetten',
        who: {
            title: 'Wie doet mee?',
            body: 'Zet aan wie meedoet. Kinderen onder de 16, voor wie jij beslist.',
            teen: '{name} beslist zelf. Dat volgt later.',
            otherFaith: '{name} heeft een eigen keuze bij geloof en doet niet mee.',
            none: 'Er zijn geen kinderen onder de 16 in het gezin.',
            pick: 'Zet minstens één kind aan.',
            and: 'en',
            joins: 'Doet mee',
            paused: 'Doet nu niet mee. De voortgang blijft bewaard.',
            notYet: 'Doet niet mee',
            toggle: '{name} doet mee',
            later: 'Aanzetten vraagt eerst je toestemming voor dat kind. Uitzetten bewaart de voortgang.',
            more: 'Ook iemand laten meedoen?',
            choose: 'Kies kinderen',
            turnedOn: '{name} doet mee.',
            turnedOff: '{name} doet nu niet mee. De voortgang blijft bewaard.',
        },
        naming: {
            title: "Hoe noemen jullie de soera's?",
            turkish: 'Fâtiha, İhlâs, Kevser',
            arabic: 'Al-Fatiha, Al-Ikhlas, Al-Kawthar',
            order: 'Volgorde',
            recommended: 'Aanbevolen: {fatiha}, dan de kortste',
            prayer: 'Volgorde van het gebed: {fatiha}, {fil} tot en met {nas}',
        },
        board: {
            title: 'Op het bord laten zien?',
            body: 'Iedereen die voor het bord staat, ziet dit bij het gekozen kind.',
            yes: 'Ja, op het bord',
            no: 'Nee, alleen in de app',
        },
        known: {
            title: 'Wat kent elk kind al?',
            body: 'Vink aan wat een kind al uit het hoofd kent. Dat geeft geen punten en geen viering.',
        },
    },
    consent: {
        title: 'Toestemming voor {name}',
        text: "We houden voor {name} bij welke soera's {name} leert en kent, alleen voor jullie gezin. Je kunt dit altijd intrekken; dan wissen we de voortgang.",
        check: 'Ik ben ouder of voogd van {name} en geef hiervoor toestemming.',
        textMany: "We houden voor {name} bij welke soera's ze leren en kennen, alleen voor jullie gezin. Je kunt dit altijd intrekken; dan wissen we de voortgang.",
        checkMany: 'Ik ben ouder of voogd van {name} en geef hiervoor toestemming.',
        give: 'Toestemming geven',
        withdraw: 'Toestemming intrekken',
        withdrawConfirm: 'Toestemming voor {name} intrekken? Dit wist de voortgang van {name} meteen. Verdiende punten blijven staan.',
        withdrawn: 'Toestemming ingetrokken. De voortgang van {name} is gewist.',
        given: 'Toestemming gegeven op {date}.',
        none: 'Nog geen toestemming',
    },
    stage: {
        none: 'Nog niet begonnen',
        learning: 'Aan het leren',
        ready: 'Wil laten horen',
        known: 'Uit het hoofd',
        review: 'Even opfrissen',
    },
    overview: {
        subtitle: "Welke soera's de kinderen uit hun hoofd leren. Ieder kind in eigen tempo.",
        now: 'Nu bezig met {item}',
        nothing: 'Nog niets begonnen',
        next: 'Volgende: {item}',
        allKnown: 'Alles uit de lijst kent {name} uit het hoofd',
        waiting: 'Wacht op luisteren ({count})',
        refresh: 'Opfrissen: {items}',
        list: 'De lijst',
        settings: 'Instellingen',
        open: 'Bekijken',
        paused: "Soera's leren staat uit. Uitzetten wist nu niets. Na 12 maanden uit wordt de voortgang gewist.",
        notSet: "Soera's leren staat nog niet aan.",
        setUp: 'Aanzetten',
        noConsent: 'Nog geen toestemming',
        disabled: 'Doet nu niet mee',
        selfDecides: 'Beslist zelf; volgt later',
    },
    member: {
        progress: '{x} van {y} uit het hoofd',
        orderLearn: 'Leervolgorde',
        orderMushaf: 'Mushafvolgorde',
        menu: 'Wat wil je doen met {item}?',
        start: 'Beginnen',
        ready: 'Wil laten horen',
        approve: 'Goed gehoord',
        practice: 'Nog even oefenen',
        markKnown: 'Heeft deze laten horen',
        baseline: 'Kende deze al',
        refresh: 'Even opfrissen',
        heard: 'Goed gehoord',
        revert: 'Per ongeluk goedgekeurd',
        revertConfirm: 'Terugdraaien? {item} staat daarna weer op Aan het leren.',
        revertPoints: 'De {count} punten van {item} gaan er weer af.',
        negative: 'Het saldo van {name} wordt dan negatief. Toch terugdraaien?',
        reset: 'Wissen',
        resetConfirm: '{item} wissen voor {name}? Het staat daarna weer op Nog niet begonnen.',
        confirm: 'Ja',
        cancel: 'Nee',
        upto: 'Tot en met vers',
        uptoHint: 'Bij een langere soera: tot waar kent {name} hem al?',
        uptoSave: 'Opslaan',
        uptoClear: 'Leegmaken',
        uptoShort: 't/m vers {n}',
        listen: 'Luisteren op Quran.com',
        verses: { one: '{count} vers', other: '{count} verzen' },
        points: { one: '{count} punt', other: '{count} punten' },
        reviewRound: 'Herhaalrondje',
        reviewRoundBody: "Luister een paar gekende soera's na. Geen punten, alleen even opfrissen.",
        reviewRoundEmpty: 'Nu niets om op te frissen.',
        reviewRoundDone: 'Herhaalrondje klaar.',
        inactive: 'Niet meer in de lijst',
        extra: 'Extra',
        heardBy: 'Gehoord door',
        heardParent: 'mij',
        heardTeacher: 'de leraar (hoca, juf)',
        milestones: 'Mijlpalen',
        divider: "{fatiha} en de tien korte soera's",
        milestone: {
            fatiha: '{fatiha} uit het hoofd',
            prayer_set: "{fatiha} en de tien korte soera's",
            starter_set: "De eerste twintig soera's",
        },
        done: 'Opgeslagen.',
        childBody: 'Tik op de knop om te beginnen of om te laten horen.',
        childStart: 'Hier ga ik mee beginnen',
        childReady: 'Ik ken deze uit mijn hoofd',
        childOops: 'Oeps',
        childReadyDone: 'Fijn. Straks luistert een ouder.',
        agedOut: "Vanaf 16 jaar beslist {name} zelf. Bij opslaan wordt de voortgang van Soera's leren van {name} gewist; punten blijven.",
        /** Golf 7 live r1: bevestiging vóór een geboortedatum die een meedoend kind 16+ maakt. */
        agedOutBirth: {
            title: 'Geboortedatum opslaan?',
            body: "Met deze geboortedatum is {name} 16 jaar of ouder. Vanaf 16 jaar beslist {name} zelf: bij opslaan wordt de voortgang van Soera's leren van {name} gewist. Punten blijven.",
            confirm: 'Opslaan en wissen',
        },
    },
    list: {
        body: 'Punten zijn voor alle kinderen hetzelfde.',
        rewardsOff: 'Beloningen staat uit: er worden geen punten gegeven.',
        up: '{item} omhoog',
        down: '{item} omlaag',
        drag: 'Sleep om te verplaatsen',
        active: 'In de lijst',
        points: 'Punten',
        presets: 'Volgorde met één knop',
        recommended: 'Aanbevolen',
        prayer: 'Volgorde van het gebed',
        more: 'Meer toevoegen',
        moreBody: "Extra: Ayat al-Kursi (een vers, geen soera). En de soera's 95 tot en met 78.",
        add: 'Toevoegen',
        remove: 'Uit de lijst halen',
        save: 'Lijst opslaan',
        saved: 'Lijst opgeslagen.',
        keptNote: 'Blijft bewaard, want er is voortgang.',
    },
    settings: {
        naming: 'Namen',
        namingTurkish: 'Turks: Fâtiha, İhlâs, Kevser',
        namingArabic: 'Arabisch: Al-Fatiha, Al-Ikhlas, Al-Kawthar',
        riwaya: 'Leeswijze',
        hafs: 'Hafs',
        warsh: 'Warsh',
        warshNote: 'Bij Warsh tonen we geen versnummers en geen link: die telling verschilt per druk.',
        refresh: 'Opfrissen na',
        days: '{count} dagen',
        never: 'Niet',
        board: 'Op het bord tonen',
        boardNote: 'Iedereen die voor het bord staat, ziet dit bij het gekozen kind.',
        consent: 'Toestemming per kind',
        wipe: 'Voortgang van iedereen wissen',
        wipeBody: 'Wist alle voortgang, de lijst en de instellingen, en trekt de toestemmingen in. Verdiende punten blijven staan.',
        wipeConfirm: 'Alles wissen? Dit kan niet ongedaan worden gemaakt.',
        wiped: "Soera's leren is gewist.",
        off: 'Uitzetten',
        offNote: 'Uitzetten wist nu niets. Na 12 maanden uit wordt de voortgang gewist.',
        on: 'Weer aanzetten',
        pointsNote: 'Na wissen blijven verdiende punten staan. Zet je het later weer aan, dan kan een soera opnieuw punten geven.',
        saved: 'Opgeslagen.',
    },
    approvals: {
        title: 'Laten horen',
        wants: '{name} wil {item} laten horen',
        wantsAgain: '{name} wil {item} opnieuw laten horen',
        since: 'Sinds {time}',
        points: { one: '{count} punt bij Goed gehoord', other: '{count} punten bij Goed gehoord' },
        approve: 'Goed gehoord',
        practice: 'Nog even oefenen',
        heardBy: 'Gehoord door',
        me: 'mij',
        teacher: 'de leraar (hoca, juf)',
        already: 'Is al gedaan.',
        approved: '{item}: goed gehoord.',
        practiced: 'Nog even oefenen. {name} kan het later opnieuw laten horen.',
        seen: 'Gezien',
        milestone: '{name}: {text}',
    },
    errors: {
        stale_stage: 'Is al gedaan.',
        revert_first: 'Draai eerst Per ongeluk goedgekeurd terug.',
        not_eligible: 'Dit kind doet (nog) niet mee.',
        consent_renewal_required: 'Geef eerst opnieuw toestemming in Wat past bij ons gezin.',
    },
};
//# sourceMappingURL=memorizeApp.nl.js.map